var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKycPendingImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 242,
    height: 262,
    viewBox: "0 0 242 262",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6925 174.645C9.74699 177.286 2.01675 237.149 0.807865 259.259C0.787324 259.612 0.845417 259.965 0.978578 260.297C1.11174 260.629 1.31718 260.932 1.58236 261.189C1.84753 261.446 2.16687 261.65 2.52086 261.789C2.87485 261.928 3.25604 262 3.64118 262C4.32518 262.006 4.98882 261.786 5.50958 261.379C6.03035 260.971 6.37308 260.405 6.4745 259.783L20.6175 176.548L11.6925 174.645Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8461 174.645C75.7916 177.286 83.5219 237.149 84.7355 259.259C84.756 259.612 84.6979 259.965 84.5648 260.297C84.4316 260.629 84.2262 260.932 83.961 261.189C83.6958 261.446 83.3765 261.65 83.0225 261.789C82.6685 261.928 82.2873 262 81.9022 262C81.2182 262.006 80.5545 261.786 80.0338 261.379C79.513 260.971 79.1703 260.405 79.0688 259.783L64.9353 176.548L73.8461 174.645Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.000376072 169.97V170.624C-0.0468459 175.321 4.35896 179.172 9.87449 179.259L75.2438 180.278C80.6791 180.365 85.2124 176.757 85.4769 172.134L85.5099 171.535C85.7838 166.712 81.326 162.653 75.6594 162.558L10.2617 161.482C4.65647 161.391 0.047598 165.229 0.000376072 169.97Z",
    fill: "url(#paint0_linear_403_1174)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M127.169 257.081C115.548 257.081 110.405 256.166 108.11 255.347C108.334 256.238 108.88 257.034 109.66 257.604C110.439 258.173 111.407 258.483 112.403 258.482H153.51C153.817 258.482 154.12 258.417 154.396 258.292C154.672 258.166 154.912 257.985 155.099 257.76C155.286 257.536 155.414 257.275 155.473 256.998C155.532 256.721 155.521 256.435 155.441 256.162C150.752 256.496 140.802 257.081 127.169 257.081Z",
    fill: "url(#paint1_linear_403_1174)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M155.441 256.149C155.375 255.916 155.26 255.698 155.101 255.507C151.97 251.834 145.657 246.07 137.124 246.178C124.586 246.343 120.218 247.592 110.476 246.248L108.177 253.243C107.955 253.923 107.932 254.644 108.11 255.334C110.405 256.166 115.548 257.068 127.169 257.068C140.802 257.081 150.752 256.496 155.441 256.149Z",
    fill: "url(#paint2_linear_403_1174)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M113.295 238.711L110.462 247.524C110.462 247.524 116.71 250.126 122.206 248.04L123.288 240.402L113.295 238.711Z",
    fill: "url(#paint3_linear_403_1174)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M198.512 251.535C189.45 258.218 184.818 260.465 182.457 261.141C183.24 261.703 184.208 262.006 185.203 261.999C186.197 261.991 187.16 261.676 187.934 261.102L219.979 237.457C220.219 237.281 220.411 237.057 220.541 236.802C220.671 236.547 220.735 236.267 220.728 235.986C220.721 235.704 220.644 235.428 220.501 235.178C220.359 234.929 220.156 234.713 219.908 234.547C216.485 237.513 209.127 243.694 198.512 251.535Z",
    fill: "url(#paint4_linear_403_1174)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M219.904 234.547C219.696 234.403 219.458 234.299 219.205 234.243C214.275 233.194 205.454 232.34 198.862 237.349C189.2 244.687 186.641 248.191 178.136 252.732L181.092 259.48C181.377 260.135 181.846 260.708 182.452 261.141C184.813 260.465 189.441 258.218 198.507 251.535C209.128 243.694 216.485 237.514 219.904 234.547Z",
    fill: "url(#paint5_linear_403_1174)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2577 141.217C51.9602 139.398 54.3582 138.445 56.8419 138.646C71.6902 139.846 124.561 144.427 136.798 149.724C149.176 155.083 131.329 220.813 126.366 238.189C125.599 240.875 126.47 242.274 123.718 242.755C119.013 243.577 113.1 238.126 113.671 233.384C115.546 217.801 119.032 184.23 116.35 169.06C115.772 165.788 112.917 163.671 109.632 163.178L55.0441 154.978C48.4886 153.993 45.7284 146.058 50.2577 141.217Z",
    fill: "url(#paint6_linear_403_1174)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M171.223 240.584C171.869 241.126 178.136 252.727 178.136 252.727C178.136 252.727 185.111 251.339 186.532 247.284L180.256 236.811L171.223 240.584Z",
    fill: "url(#paint7_linear_403_1174)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8981 137.876C13.7658 137.821 9.86118 140.299 9.22104 144.382C8.95814 146.059 8.83818 147.755 8.86404 149.456C8.99626 158.663 17.0523 166.136 27.0681 166.596L109.315 170.039C110.159 170.075 110.969 170.358 111.625 170.849C112.28 171.339 112.747 172.01 112.955 172.763C114.887 179.628 124.336 200.71 170.51 242.783C171.108 243.326 171.89 243.668 172.727 243.751C173.564 243.835 174.407 243.655 175.118 243.243L181.692 239.43C182.024 239.238 182.261 238.934 182.354 238.584C182.446 238.233 182.387 237.863 182.188 237.553L134.29 162.449C131.776 158.637 127.734 155.882 123.033 154.777L54.0116 138.589C53.3063 138.424 52.585 138.335 51.8606 138.326L17.8981 137.876Z",
    fill: "url(#paint8_linear_403_1174)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M106.462 22.1533C106.462 22.1533 83.2905 34.7782 74.3184 41.7087L92.886 51.2196C92.886 51.2196 102.916 40.5767 112.478 36.14L106.462 22.1533Z",
    fill: "url(#paint9_linear_403_1174)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4447 133.645C9.91072 136.258 11.6074 138.776 14.2445 139.177C21.5968 140.297 36.5308 141.805 51.2781 138.711C52.3644 138.483 53.3127 137.893 54.0143 137.033C58.7878 131.181 78.4997 107.179 90.0335 95.5948C92.1369 93.4823 95.6267 93.862 97.6539 96.0478C104.601 103.539 121.864 118.53 151.051 121.831C152.279 121.97 153.466 121.307 154.008 120.196C154.753 118.665 154.08 116.816 152.545 116.08C144.428 112.193 121.159 99.8429 112.974 82.5366C102.991 61.4286 98.9824 52.4685 89.9016 46.9432C84.2349 43.5127 80.8586 41.1707 79.1066 39.8956C78.6436 39.5564 78.0784 39.3558 77.4873 39.3209C76.8962 39.286 76.3076 39.4185 75.8011 39.7005C66.3764 44.9634 22.9902 72.239 10.4447 133.645Z",
    fill: "url(#paint10_linear_403_1174)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8765 90.7893C92.7303 90.7898 92.5859 90.7591 92.4548 90.6997C92.3237 90.6402 92.2094 90.5536 92.121 90.4467C85.0944 82.033 81.0569 72.4614 81.0191 72.3659C80.9289 72.1503 80.9357 71.9105 81.038 71.6995C81.1403 71.4884 81.3297 71.3233 81.5645 71.2405C81.7993 71.1577 82.0604 71.1639 82.2902 71.2579C82.52 71.3518 82.6997 71.5257 82.7899 71.7414C82.8277 71.8368 86.7707 81.1786 93.6274 89.3885C93.704 89.4791 93.7603 89.5827 93.793 89.6934C93.8258 89.8041 93.8342 89.9197 93.818 90.0335C93.8017 90.1472 93.7611 90.2569 93.6984 90.3561C93.6356 90.4553 93.5521 90.5421 93.4526 90.6115C93.2872 90.7274 93.0846 90.7899 92.8765 90.7893Z",
    fill: "url(#paint11_linear_403_1174)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M150.662 114.921L155.247 113.802L169.168 110.84C169.998 110.664 170.857 110.64 171.697 110.77C172.537 110.901 173.34 111.182 174.06 111.599L186.031 118.512L152.976 118.464L150.662 114.921Z",
    fill: "url(#paint12_linear_403_1174)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M129.096 12.8982C129.162 13.3319 123.165 40.3078 123.165 40.3078L106.429 36.8556L107.973 10.4912C107.973 10.4912 127.995 5.99378 129.096 12.8982Z",
    fill: "url(#paint13_linear_403_1174)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M111.737 16.346L109.735 30.1635C109.709 30.3405 109.709 30.5199 109.735 30.6969C109.9 31.7768 110.778 35.4676 114.835 34.4094C118.509 33.4552 121.885 32.6312 124.213 33.2861C124.717 33.4283 125.145 33.7373 125.415 34.1533C125.685 34.5692 125.776 35.0624 125.672 35.537C125.124 37.9874 123.783 43.4953 121.824 48.1142C121.63 48.5666 121.259 48.9358 120.783 49.1487C120.307 49.3616 119.762 49.4025 119.255 49.2634C116.086 48.4177 109.456 46.4531 104.526 43.7295C104.201 43.5518 103.933 43.2971 103.751 42.992C103.569 42.6868 103.48 42.3424 103.492 41.9947C103.653 38.5251 104.097 27.8996 103.723 24.9288C103.374 22.1358 99.6435 20.4661 98.0238 19.8676C97.7612 19.7707 97.5228 19.6257 97.3231 19.4416C97.1234 19.2574 96.9666 19.0379 96.8621 18.7963C96.1113 17.0615 95.0771 13.0759 100.56 11.4235C100.831 11.343 101.082 11.2132 101.297 11.0418C101.513 10.8704 101.689 10.6609 101.814 10.4258C101.94 10.1907 102.013 9.93474 102.028 9.67325C102.044 9.41176 102.002 9.15005 101.905 8.90372C101.093 6.82632 100.753 3.66034 104.994 1.91255C109.234 0.164758 112.521 2.25083 114.259 3.96392C114.601 4.29574 115.059 4.50694 115.554 4.56081C116.048 4.61469 116.547 4.50786 116.964 4.25886C117.249 4.09214 117.581 4.00831 117.918 4.01837C118.256 4.02844 118.581 4.1319 118.853 4.31522C119.103 4.45303 119.381 4.54135 119.669 4.5745C119.958 4.60764 120.251 4.58488 120.529 4.50766C120.808 4.43043 121.066 4.30046 121.286 4.12614C121.507 3.95181 121.685 3.73701 121.809 3.49555C122.844 1.54826 124.945 -0.537827 129.167 0.125727C136.656 1.30538 137.506 8.92542 135.527 13.3925C133.549 17.8596 125.512 16.1551 121.479 13.9042C118.414 12.1955 114.433 13.9866 112.705 14.9451C112.441 15.0985 112.217 15.3036 112.05 15.5459C111.883 15.7881 111.776 16.0613 111.737 16.346Z",
    fill: "url(#paint14_linear_403_1174)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M103.058 29.9465C103.058 29.9465 106.136 22.0316 102.977 20.093C99.8182 18.1543 95.129 19.1605 96.1585 24.894C97.4571 32.0283 103.058 29.9465 103.058 29.9465Z",
    fill: "url(#paint15_linear_403_1174)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M137.893 124.462H138.068L208.684 124.397C209.52 124.397 210.323 124.091 210.914 123.548C211.506 123.005 211.838 122.268 211.838 121.5C211.838 120.731 211.506 119.994 210.914 119.451C210.323 118.908 209.52 118.603 208.684 118.603L138.068 118.668C137.248 118.671 136.461 118.969 135.875 119.496C135.29 120.024 134.951 120.74 134.93 121.493C134.91 122.246 135.21 122.977 135.767 123.53C136.323 124.084 137.093 124.416 137.912 124.457L137.893 124.462Z",
    fill: "url(#paint16_linear_403_1174)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M236.016 60.9604L235.945 61.0948L206.233 119.93C206.059 120.275 205.961 120.649 205.944 121.029C205.927 121.409 205.992 121.789 206.135 122.146C206.278 122.503 206.496 122.831 206.777 123.111C207.058 123.391 207.396 123.617 207.772 123.777C208.148 123.937 208.555 124.027 208.969 124.042C209.383 124.058 209.796 123.998 210.185 123.867C210.574 123.735 210.931 123.535 211.236 123.277C211.541 123.019 211.787 122.708 211.961 122.363L241.673 63.5322C242.044 62.8421 242.102 62.0447 241.833 61.3156C241.564 60.5864 240.991 59.9852 240.24 59.6441C239.488 59.3031 238.62 59.2502 237.826 59.497C237.032 59.7439 236.378 60.2702 236.006 60.9604H236.016Z",
    fill: "url(#paint17_linear_403_1174)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M169.338 127.728C169.027 128.903 139.565 230.392 132.094 256.101C131.89 256.789 131.859 257.51 132.006 258.209C132.153 258.908 132.473 259.568 132.941 260.135C133.409 260.703 134.013 261.165 134.707 261.484C135.4 261.804 136.164 261.973 136.939 261.978C138.065 261.974 139.157 261.624 140.04 260.983C140.923 260.342 141.548 259.448 141.813 258.443L174.519 136.649L169.338 127.728Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M185.469 127.728C185.781 128.903 215.219 230.392 222.713 256.101C222.922 256.79 222.956 257.513 222.811 258.215C222.667 258.916 222.348 259.578 221.88 260.149C221.412 260.719 220.807 261.183 220.112 261.504C219.417 261.825 218.651 261.995 217.873 262C216.747 261.996 215.656 261.645 214.772 261.005C213.889 260.364 213.265 259.47 213 258.465L180.294 136.67L185.469 127.728Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M186.707 124.41H168.347V137.946C168.342 138.872 168.736 139.763 169.444 140.423C170.152 141.083 171.116 141.458 172.124 141.467H174.641V171.87C174.638 172.572 174.937 173.246 175.475 173.746C176.012 174.245 176.743 174.528 177.508 174.532C177.887 174.531 178.262 174.46 178.611 174.326C178.96 174.191 179.277 173.994 179.544 173.747C179.81 173.5 180.021 173.207 180.165 172.885C180.308 172.562 180.381 172.218 180.379 171.87V141.467H181.654C182.32 141.466 182.98 141.344 183.595 141.109C184.21 140.873 184.768 140.528 185.237 140.093C185.707 139.659 186.078 139.144 186.33 138.577C186.582 138.011 186.71 137.404 186.707 136.792V124.41Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M123.226 121.157H225.698C226.394 121.159 227.071 121.373 227.621 121.765C228.171 122.157 228.564 122.706 228.739 123.326L230.156 128.478C230.278 128.908 230.292 129.358 230.196 129.794C230.099 130.23 229.896 130.639 229.6 130.991C229.305 131.344 228.925 131.629 228.491 131.825C228.057 132.022 227.58 132.125 227.096 132.125L121.956 131.566C121.476 131.56 121.004 131.454 120.575 131.257C120.147 131.059 119.772 130.774 119.481 130.424C119.189 130.074 118.988 129.668 118.893 129.236C118.797 128.804 118.809 128.358 118.929 127.932L120.171 123.343C120.343 122.719 120.737 122.165 121.29 121.769C121.844 121.373 122.525 121.158 123.226 121.157Z",
    fill: "url(#paint18_linear_403_1174)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_403_1174",
    x1: 160281,
    y1: 38349,
    x2: 160108,
    y2: 102751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_403_1174",
    x1: 26441.9,
    y1: 4969.25,
    x2: 31199.4,
    y2: 4969.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_403_1174",
    x1: 144.627,
    y1: 173.192,
    x2: 133.67,
    y2: 255.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_403_1174",
    x1: 110.476,
    y1: 243.781,
    x2: 123.302,
    y2: 243.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_403_1174",
    x1: 27470,
    y1: 40958.8,
    x2: 30571.9,
    y2: 40958.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_403_1174",
    x1: 32286.7,
    y1: 37076.1,
    x2: 31776.9,
    y2: 42386.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_403_1174",
    x1: 41.0389,
    y1: 149.239,
    x2: 142.237,
    y2: 152.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD18C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E552FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_403_1174",
    x1: 10722.6,
    y1: 23720.3,
    x2: 11218.9,
    y2: 23720.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_403_1174",
    x1: 11.3913,
    y1: 148.825,
    x2: 184.019,
    y2: 158.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD18C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E552FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_403_1174",
    x1: 21376,
    y1: 28167,
    x2: 19978.4,
    y2: 29927.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_403_1174",
    x1: 11.6847,
    y1: 49.8604,
    x2: 156.661,
    y2: 56.9861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21BCD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5AE5FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_403_1174",
    x1: 6490.83,
    y1: 21594.6,
    x2: 6841.54,
    y2: 21594.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_403_1174",
    x1: 22987.5,
    y1: 9306.4,
    x2: 25636.7,
    y2: 9306.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_403_1174",
    x1: 17598.4,
    y1: 78474.1,
    x2: 15603.2,
    y2: 81026.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_403_1174",
    x1: 26588,
    y1: 125598,
    x2: 30038.1,
    y2: 125056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_403_1174",
    x1: 5641.87,
    y1: 28202.6,
    x2: 6184.16,
    y2: 27636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_403_1174",
    x1: -762810,
    y1: -124794,
    x2: -762705,
    y2: -121539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_403_1174",
    x1: 1026760,
    y1: 271602,
    x2: 1013480,
    y2: 282040,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_403_1174",
    x1: 78591,
    y1: 8347.84,
    x2: 78584.6,
    y2: 12132.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKycPendingImg);
export default __webpack_public_path__ + "static/media/kycPendingImg.60a2ad015b15ce267a30c21fe2fe0401.svg";
export { ForwardRef as ReactComponent };